import React from 'react'
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { TextField, Button } from '@mui/material';
import { filterList } from '../utils/utils';
import LocationCityRoundedIcon from '@mui/icons-material/LocationCityRounded';

import { useDispatch } from 'react-redux';
import { setCity } from './../features/city'
import { pushCity } from '../features/favuriteCity';

import WhiteCard from './WhiteBox';


export default function FavuriteCitySelector(props) {
  const [cityList, setCityList] = React.useState([])
  const dispatch = useDispatch()
  const handleSearch = (event) => {
    event.preventDefault()
    let toSearch = event.target[0].value
    filterList(toSearch).then(l => setCityList(l))
  }

  const handleCitySelected = (city) => {
    dispatch(setCity(city))
    dispatch(pushCity(city))
    props.handleClose()
  }

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Seleziona la tua città preferita
        </Typography>
        <form action="" onSubmit={handleSearch}>
          <TextField id="outlined-basic" label="Cerca una città" variant="standard" /><br></br>
          <Button type='submit' variant='contained' style={{marginTop:'20px', display:'block'}} >Cerca</Button>
        </form>
        <hr></hr>
        <div id="cityList">
          {
            cityList.map(e => {
              return <WhiteCard key={e.id} id={e} selected={handleCitySelected} content={<p>{e.name}</p>} icon={<LocationCityRoundedIcon />} style={{marginBottom:'15px'}} />
            })
          }
        </div>
      </Box>
    </Modal>
  )
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight:'90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'auto',
  borderRadius: '20px'
};